export default "__VITE_ASSET__BbuAK1uH__"